



























































/* eslint-disable */
import { Component, Prop, Vue } from 'vue-property-decorator';
import LockIcon from 'mdi-vue/Lock.vue';

@Component({
  components: {
    LockIcon,
  },
})
export default class MerchantSetting extends Vue {
  @Prop(Object) layoutSetting!: any;

  get styleLogo() {
    try {
      return {
        background: this.layoutSetting.logo_footer_color,
      }
    } catch (error) {
      console.log(error);
      return {};
    }
  }

  get styleHeader() {
    try {
      return {
        background: this.layoutSetting.header_bar_head_box_color,
        height: '25px',
      }
    } catch (error) {
      console.log(error);
      return {};
    }
  }
}
